import React, { useContext, useEffect, useMemo, useState } from "react";
import ExamEditWidget from "../ExamEditWidget";
import {
    errorMessage,
    isTrue,
    QuestionType
} from "../../../../../service/service";
import moment from "moment";
import {
    cancelPaper,
    countTotalScore,
    DeleteHomeWorkProps,
    PaperType,
    savePaper
} from "../../../../../service/homework";
import { Button, Col, DatePicker, Icon, message, Row } from "antd";
import usePromiseCallback from "../../../../../utils/usePromiseCallback";
import style from "./HomeworkEditWidget.module.scss";
import HomeworkContext from "../../context";
import classNames from "classnames";
import DeleteConfirm from "../../../../../components/DeleteConfirm";
import useRequestFn from "../../../../../utils/useRequestFn";
import { useParams } from "react-router-dom";

export interface HomeworkEditWidgetProps {
    examName: string;
    sortType: (topicTypes: QuestionType[], sort: boolean) => void;
    examTypeList: QuestionType[];
    paperData?: PaperType | null;
}

export default function HomeworkEditWidget({
    paperData,
    examName,
    sortType,
    examTypeList
}: HomeworkEditWidgetProps) {
    const [date, setDate] = useState(
        paperData && paperData.date
            ? moment(paperData.date)
            : moment(moment().add(1, "days").format("YYYY-MM-DD 23:59:59"))
    );

    const { paperParams, topics, lockEdit, loadPaperData } =
        useContext(HomeworkContext);
    const totalScore = useMemo(() => countTotalScore(topics), [topics]);
    const [isPublished, setIsPublished] = useState(
        paperData ? isTrue(paperData.ispublish) : false
    );

    useEffect(
        () => setIsPublished(isTrue(paperData?.ispublish)),
        [paperData?.ispublish]
    );

    // 保存试卷
    const onSave = usePromiseCallback(async () => {
        if (!date) return message.error("请选择截止日期!");

        try {
            if (isPublished) {
                await cancelPaper(paperParams);
                setIsPublished(false);
                loadPaperData();
                await message.info("已经取消发布!");
            } else {
                await savePaper({
                    paperParams,
                    score: totalScore,
                    date: date.format("YYYY-MM-DD HH:mm:ss")
                });
                setIsPublished(true);
                loadPaperData();
                await message.info("作业已经发给学生们了!");
            }
        } catch (e) {
            await message.error(errorMessage(e));
        }
    });

    const disabledDate = (current: moment.Moment | null) => {
        if (!current) return false;
        return current < moment().startOf("day");
    };

    const { courseNo, courseSeq, section, week, weekTimeId, weekTime } =
        useParams();

    const [deleteAction, { loading: deleteLoading }] =
        useRequestFn(DeleteHomeWorkProps);
    async function onDelete() {
        try {
            await deleteAction({
                courseNo,
                courseSeq,
                id: paperData?.id || -1,
                section,
                week,
                weekTime,
                weekTimeId
            });
            window.location.reload();
        } catch (e) {
            await message.error(errorMessage(e));
        }
    }
    return (
        <div
            className={classNames(
                paperData?.id ? style.haveId : style.notHaveId
            )}>
            <ExamEditWidget
                examName={examName}
                sortType={sortType}
                examTypeList={examTypeList}>
                <Row className={style.item} style={{ marginTop: 30 }}>
                    <Col span={6} className={style.label}>
                        截止时间：
                    </Col>
                    <Col span={18}>
                        <DatePicker
                            showTime
                            className={style.Input}
                            defaultValue={date}
                            onChange={value => setDate(value!)}
                            disabled={isPublished}
                            disabledDate={disabledDate}
                            format="YYYY-MM-DD HH:mm:ss"
                            placeholder="请选择日期时间"
                        />
                    </Col>
                </Row>

                <Row style={{ marginTop: 20 }}>
                    <Col span={24}>
                        <Button
                            type={isPublished ? "danger" : "primary"}
                            block
                            onClick={onSave}>
                            <Icon type="check-circle" theme="filled" />{" "}
                            {isPublished ? "取消发布" : "发布作业"}
                        </Button>
                        {!isPublished && Array.isArray(paperData?.topics) && (
                            <DeleteConfirm
                                onSuccess={onDelete}
                                title="确认删除本次作业？"
                                content="删除作业后，学生的作答记录以及得分将无法恢复，请谨慎操作">
                                <Button
                                    loading={deleteLoading}
                                    style={{ marginTop: 20 }}
                                    type="danger"
                                    ghost
                                    block>
                                    <Icon type="delete" theme="filled" />
                                    删除作业
                                </Button>
                            </DeleteConfirm>
                        )}
                    </Col>
                </Row>
            </ExamEditWidget>
        </div>
    );
}
